<template>
  <div class="info-item info-block">
    <div class="info-item-body">
      <div
        class="feed-image feed-photo feed-video"
        @click="open"
        :style="{
          'background-image': video.image ? 'url(' + video.image + ')' : '',
        }"
      >
        <div v-if="!video.image" class="feed-photo-process">
          <span v-if="video.ready">
            {{ $t("feed.videoProcessingError") }}
          </span>
          <span v-else>
            {{ $t("feed.videoProcessing") }}
          </span>
        </div>
      </div>
    </div>
    <div class="info-item-footer">
      <div @click="open" class="feed-photo-comments">
        {{ video.comment_count }}
      </div>
      <div
        @click="vote"
        class="feed-photo-likes"
        :class="{
          'feed-photo-loader': voteLoader,
          'feed-photo-liked': video.liked,
        }"
      >
        {{ video.likes }}
      </div>
      <div class="info-right">
        <redirectButton
          pathname="profile"
          :params="{ id: video.owner.id }"
          :html="video.owner.name"
          class="info-author"
        ></redirectButton>
        <div class="info-time">
          {{ getVerbalDate(video.time * 1000) }}
        </div>
        <redirectButton
          pathname="profile"
          :params="{ id: video.owner.id }"
          :html="''"
          :style="{
            'background-image': video.owner.avatar
              ? 'url(' + video.owner.avatar + ')'
              : '',
          }"
          class="info-avatar"
          :class="{ 'no-avatar': !video.owner.avatar }"
        ></redirectButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import { formatDateTime } from "@/mixins/formatDateTime";

export default {
  name: "FeedVideo",
  props: {
    i18n: Object,
  },
  components: {
    redirectButton,
  },
  mixins: [formatDateTime],
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      initialHeight: 0,
      maxHeight: 240,
      showLink: false,
      textShort: false,
      voteLoader: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      userIsEmpty: "user/isEmpty",
    }),
  },
  methods: {
    open() {
      this.$modal.show("photo-details", {
        id: this.video.id,
        isAlbum: true,
        feed: true,
        fromEvents: true,
        isVideo: true,
      });
    },
    vote() {
      if (this.userIsEmpty("user")) {
        this.$modal.show("welcome");
        return;
      }
      this.voteLoader = true;
      this.$store
        .dispatch("home/vote", { id: this.video.id, type: "videos" })
        .then(() => {
          this.voteLoader = false;
        })
        .catch(() => {
          this.voteLoader = false;
        });
    },
  },
};
</script>
